/**
 * Preferenza aperto/chiuso del pannello AI laterale della chat.
 * Sotto i 1440px di larghezza finestra il pannello parte chiuso, per lasciare
 * spazio alla conversazione; se l'utente lo apre o lo chiude, la scelta vale
 * da li' in poi (salvata nel browser, con try/catch: in finestra privata o con
 * i dati del sito bloccati si torna semplicemente alla regola della larghezza).
 */

export const RIGHT_PANEL_AUTO_COLLAPSE_BELOW = 1440;
export const RIGHT_PANEL_STORAGE_KEY = 'whatsapp_right_panel_state';

export type PanelPref = 'open' | 'closed';

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

/** true = il pannello parte chiuso. La scelta salvata vince sulla larghezza. */
export function initialPanelCollapsed(viewportWidth: number, stored: PanelPref | null): boolean {
  if (stored === 'closed') return true;
  if (stored === 'open') return false;
  return viewportWidth < RIGHT_PANEL_AUTO_COLLAPSE_BELOW;
}

export function readPanelPref(storage: StorageLike | null | undefined): PanelPref | null {
  try {
    const v = storage?.getItem(RIGHT_PANEL_STORAGE_KEY);
    return v === 'open' || v === 'closed' ? v : null;
  } catch {
    return null;
  }
}

export function writePanelPref(storage: StorageLike | null | undefined, collapsed: boolean): void {
  try {
    storage?.setItem(RIGHT_PANEL_STORAGE_KEY, collapsed ? 'closed' : 'open');
  } catch {
    /* storage non disponibile: la scelta vale solo per questa visita */
  }
}

/** Accesso sicuro a localStorage (puo' lanciare gia' in lettura della proprieta'). */
export function safeLocalStorage(): StorageLike | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}
